import { history } from "../helpers/history"
import client from "../services/feathers"

export const servicesSocket = (user, props, token) => {
    const userService = client.service('users')
    // estado del usuario
    userService.on('patched', userPatch => {
        //console.log(userPatch)
        const { id, state } = userPatch
        if (id === user.id) {
            if (!state) {
                // console.log(' mi usuario', userPatch, user)
                client.logout().then(r => {/* console.log('usuario inhabilitado ', r) */})
                history.push('/home')
            }
        } 
    })

    // notificaciones
    const notificationsService = client.service('notifications');
        notificationsService.on('created', notification => {
        })

    // parametros
    client.service('parameters').on('updated', parameter => {
        // console.log('Se actualizo el parameter', parameter)
        props.updateParams(parameter)
    })
    // parametros
    client.service('quotas').on('patched', quota => {
        if (quota.cedule === user.identification) {
            // console.log('Se actualizo el quotas', quota)
            props.updateQuotasReduce(quota)
           //  this.props.updateParams(parameter)
        }
    
    })

    client.service('verificates').on('patched', verificate => {
        //console.log(user)
        //alert(token)
        if (user.id === verificate.user && (token === verificate.token || token === undefined) ) {
            //alert("cerrar sesion")
            client.logout().then(r => {/* (console.log('cerrando sesion ')) */})
            history.push('/home')
           //  this.props.updateParams(parameter)
        }
    })

    // servicios
    client.service('agreement-types').on('patched', agreementType => {
        // console.log('Se actualizo el servicio', agreementType)
        props.updateAgreementTypes(agreementType)
    })

}